module.exports = __webpack_public_path__ + "assets/img/KeyReport_Bagnara.690462ac-ps.jpg";